import React from 'react';
import Loading from '../components/Loading'

const NotFound = () => {

    return (
        <div style={{margin:'10vh auto',display:'block',width:'80vw'}} fallback={<Loading />}>
            <h1>404 Page not found</h1><br/>
            <p>Take me <a href={'/'}>back</a></p>
        </div>
    );
}

export default NotFound;
